module.exports = __webpack_public_path__ + "img/acounto_logo-01n.60c0be73.svg";